export class Theme {
    themeProps = 'blankThemeProps';
    showBreadCrumbs = true;
    showPDFPreview = true;
    language = 'en';

    public constructor(init?: Partial<Theme>) {
        Object.assign(this, init);
    }
}
